import React from 'react';
import { Cell, Row } from '../../../components';
import { AssetWrapper } from '../../Assets/components/Asset.styles';
import { FeedItemGroup } from '../Feed.types';
import { FeedItem } from './Feed.component';
import { configService } from '../../../services';

export const FeedItemCollection: React.FC<FeedItemGroup> = ({
  FeedItems,
}) => {

  const appId = configService.current().theme.Id;
  if (["zebratechnologies", "ricoh-rewards"].includes(appId as string)) {
    return <>
      <div className='row'>
        {FeedItems.map((a, inx) => (
          <div key={inx} className='col-12 col-md-6 col-md-6 col-lg-4 mb-4 mb-lg-0 d-flex'>
            {/* <div className='card'></div> */}
            <FeedItem {...a} key={inx} />
          </div>
        ))}
      </div>
    </>
  }


  return (
    <section>
      <div className="w-100">
        <Row>
          {FeedItems.map((a, inx) => (
            <Cell key={inx} $baseSize={6} $SMSize={4} $MDSize={6} $LGSize={4} $XLSize={3}>
              <AssetWrapper>
                <FeedItem {...a} key={inx} />
              </AssetWrapper>
            </Cell>
          ))}
        </Row>
      </div>
    </section>
  )
}